export default "__VITE_ASSET__zbIoGTfo__"